import { FC } from 'react';
import styles from './ToastMessages.module.scss';
import { useToast } from 'contexts/ToastContext';
import Toast from './Toast/Toast';

const ToastMessages: FC = () => {
  const { toasts, removeToast } = useToast();

  const handleClose = (toastMessageId?: number): void => {
    if (toastMessageId) {
      removeToast(toastMessageId);
    }
  };

  return (
    <div className={styles.toastContainer} data-testid="toastMessages">
      {toasts.map(toastMessage => (
        <Toast key={toastMessage.id} toastMessage={toastMessage} onClose={handleClose} />
      ))}
    </div>
  );
};

export default ToastMessages;
